import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  createFilteredUrl,
  isTileClickable, 
  getTileTooltip, 
  TileDataWithDrillDown 
} from '../../../utils/urlUtils';

interface BackgroundTasksTileProps {
  data: TileDataWithDrillDown & {
    data?: {
      Completed?: number;
      Total?: number;
      completed?: number;  // camelCase fallback
      total?: number;      // camelCase fallback
    };
  };
}

export const BackgroundTasksTile: React.FC<BackgroundTasksTileProps> = ({ data }) => {
  const navigate = useNavigate();
  // Try both PascalCase and camelCase versions due to JSON serialization
  const tileData = data.data || {};
  const completed = tileData.Completed ?? tileData.completed ?? 0;
  const total = tileData.Total ?? tileData.total ?? 0;
  
  // Debug: log the actual data structure
  console.log('BackgroundTasksTile data:', { data, tileData, completed, total });
  
  const isClickable = isTileClickable(data);
  const tooltip = getTileTooltip(data);

  const handleClick = () => {
    if (isClickable && data.drillDown?.filters !== undefined) {
      // Background tasks should navigate to automation/background-tasks page
      const url = createFilteredUrl('/automation/background-tasks', data.drillDown.filters);
      navigate(url);
    }
  };

  return (
    <div
      className={`
        flex flex-col items-center justify-center leading-relaxed min-h-44
        ${isClickable ? 'cursor-pointer hover:bg-gray-50 dark:hover:bg-white/5 active:bg-gray-100 dark:active:bg-white/10 transition-colors duration-200 rounded-lg' : ''}
      `}
      onClick={handleClick}
      title={tooltip}
      style={isClickable ? { touchAction: 'manipulation' } : undefined}
    >
      <div className="text-3xl font-bold text-blue-600 dark:text-graphite-accent mb-2">
        {completed}/{total}
      </div>
      <div className="text-sm text-gray-600 dark:text-graphite-muted text-center">
        Background úlohy
      </div>
      {total > 0 && (
        <div className="w-full bg-gray-200 dark:bg-white/10 rounded-full h-3 md:h-2 mt-3">
          <div
            className="bg-blue-600 dark:bg-graphite-accent h-3 md:h-2 rounded-full transition-all"
            style={{ width: `${(completed / total) * 100}%` }}
          ></div>
        </div>
      )}
    </div>
  );
};
